import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=25a2681f&scoped=true"
import script from "./CommonSection.vue?vue&type=script&lang=ts"
export * from "./CommonSection.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=25a2681f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2681f",
  null
  
)

export default component.exports